import React from "react";
import { Link } from "react-router-dom";

import Reveal, { RevealList } from "../motion/Reveal";
import { useT } from "../../i18n";
import { SERVICES } from "../../content/services";

// Cross-navigation at the foot of every service page: the other six, three to
// a row. Hairline over each cell, no boxes.

export default function OtherServices({ currentSlug }) {
  const { t } = useT();
  const others = SERVICES.filter((s) => s.slug !== currentSlug);

  return (
    <section className="section-t py-14 lg:pt-16 lg:pb-[88px]">
      <div className="shell flex flex-col gap-7">
        <Reveal distance={8}>
          <h2 className="t-label">{t("services.otherServices")}</h2>
        </Reveal>

        <RevealList
          className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10"
          itemAs="div"
          items={others.map((s) => ({ key: s.slug, ...s }))}
          step={50}
        >
          {({ slug }) => (
            <Link to={`/${slug}`} className="row-link group block border-t border-line-subtle pt-5">
              <div className="row-title font-heading text-[17px] font-semibold tracking-[-0.3px] text-fg transition-colors duration-200">
                {t(`services.${slug}.title`)}
              </div>
              <p className="mt-2 font-body text-[13.5px] leading-[1.6] text-fg-muted">
                {t(`services.${slug}.tagline`)}
              </p>
            </Link>
          )}
        </RevealList>
      </div>
    </section>
  );
}
